import type { FunctionReference, FunctionReturnType } from "convex/server";
import { Context, type Effect, type Stream } from "effect";

export interface ConvexClientService {
	query<Query extends FunctionReference<"query">>(
		query: Query,
		args: Query["_args"],
	): Effect.Effect<FunctionReturnType<Query>>;

	mutation<Mutation extends FunctionReference<"mutation">>(
		mutation: Mutation,
		args: Mutation["_args"],
	): Effect.Effect<FunctionReturnType<Mutation>>;

	action<Action extends FunctionReference<"action">>(
		action: Action,
		args: Action["_args"],
	): Effect.Effect<FunctionReturnType<Action>>;

	subscribe<Query extends FunctionReference<"query">>(
		query: Query,
		args: Query["_args"],
	): Stream.Stream<FunctionReturnType<Query>>;
}

export class ConvexClient extends Context.Tag("@confect/ConvexClient")<
	ConvexClient,
	ConvexClientService
>() {}
